module.exports = __webpack_public_path__ + "img/logo.df3f7241.png";